 <template>
  <button
    @click="click"
    :class="this.variant"
    :disabled="variant === 'disabled'"
    class="sc-gradient-action">
      <slot></slot>
  </button>
</template>

<script>

export default {
  name: 'ScGradientActionButton',
  props: {
    variant: {
      type: String,
      default: 'default'
    }
  },
  methods: {
    click: function () {
      this.$emit('click')
    }
  }
}
</script>

<style scoped lang="scss">
$height: $sc-gradientaction-height;
$width: 100%;

.sc-gradient-action {
  cursor: pointer;
  font-weight: $sc-gradientaction-font-weight;
  transition: background-image 0.2s, background-color 0.2s;

  &.default {
    background-image: linear-gradient(to right, $sc-gradientaction-start-color, $sc-gradientaction-end-color);
    border: 0;
    color: $sc-gradientaction-color;
    width: $width;
    height: $height;

    &:hover {
      background-image: linear-gradient(to right, $sc-gradientaction-end-color, $sc-gradientaction-end-color);
    }
  }

  &.outline {
    background-color: transparent;
    border: 2px solid $sc-gradientaction-color-outline;
    color: $sc-gradientaction-color-outline;
    width: $width;
    height: $height;

    &:hover {
      background-color: $sc-gradientaction-hover-bg;
    }
  }

  &.disabled {
    background-image: linear-gradient(to right, $sc-gradientaction-disabled-start-color, $sc-gradientaction-disabled-end-color);
    border: 0;
    color: $sc-text-dark;
    width: $width;
    height: $height;
    cursor: auto;
  }
}
</style>
